import Axios from "axios";
import { buildWebStorage, setupCache } from 'axios-cache-interceptor';
import { getHost } from "../helpers/Common";
import { JobQuestion, SMSServiceModel, VacancyEditResponse, VacancyQuestionModel } from "../models/VacancyPostingModel";
import { PreApplicationQuestionModel } from "../models/PreApplicationQuestionModel";
import { JobApplicationStageEmail } from "../models/JobApplicationStageEmail";

const instance = Axios.create();
const axios = setupCache(instance, { storage: buildWebStorage(localStorage, 'axios-cache:') });
const apiBaseUrl = getHost() + "api/";

export async function getVacancy(recruiterId: number, token: string, jobId?: number, orgId?: number) {   
    return new Promise<any>((resolve, reject) => {
        axios 
        .get(apiBaseUrl + "vacancy/vacancyPostingDetails", {
            params: {   
                recruiterId: recruiterId,
                vacancyId: jobId,
                organizationId: orgId
            },
            headers: {
                'Authorization' : `Bearer ${token}`
            },
            cache: false
        })
        .then((response) => {
            resolve(response.data);
        })
        .catch((error) => {
            reject(error);
        })
    })
}

export async function postVacancy(formData: FormData, recruiterId: number, token: string) {   
    return new Promise<any>((resolve, reject) => {
        axios 
        .post(apiBaseUrl + "vacancy/saveVacancy", formData, {
            headers: {
                'Authorization' : `Bearer ${token}`,
                'Content-Type': 'multipart/form-data'
            },
            params: {   
                recruiterId: recruiterId
            }
        })
        .then((response) => {
            resolve(response.data);          
        })
        .catch((error) => {
            reject(error);
        })
    })
}

export async function removeJobImage(recruiterId: number, token: string, jobId?: number) {   
    return new Promise<any>((resolve, reject) => {
        axios 
        .delete(apiBaseUrl + `vacancy/removeJobImage?recruiterId=${recruiterId}&jobId=${jobId}`, {
            headers: {
                'Authorization' : `Bearer ${token}`
            }
        })
        .then((response) => {
            resolve(response.data);
        })
        .catch((error) => {
            reject(error);
        })
    })
}

export async function postSamplteQuestionToJob(sampleQuestionId: number, recruiterId: number, token: string, jobId?: number) {   
    return new Promise<any>((resolve, reject) => {
        axios 
        .post(apiBaseUrl + "vacancy/sampleVacancyQuestions", {
            sampleQuestionId,
            jobId
        },
        {
            headers: {
                'Authorization' : `Bearer ${token}`
            },
            params: {
                recruiterId
            }
        })
        .then((response) => { 
            resolve(response.data);
        })
        .catch((error) => {
            reject(error);
        })
    })
}

export async function postUpdateVacancy(updateJobDetails:VacancyQuestionModel, recruiterId: number, token: string) {  
    return new Promise<any>((resolve, reject) => {
        axios 
        .post(apiBaseUrl + "vacancy/vacancyQuestionStatus", updateJobDetails, {
            headers: {
                "Content-Type": "application/json",
                'Authorization' : `Bearer ${token}`
            },
            params: {   
                recruiterId: recruiterId
            }
        })
        .then((response) => {
            resolve(response.data);          
        })
        .catch((error) => {
            reject(error);
        })
    })
}

export async function getSampleQuestions() {
    return new Promise<any>((resolve, reject) => {
        axios
        .get(apiBaseUrl + "vacancy/sampleVacancyQuestions")
        .then((response) => {
            resolve(response.data);
        })
        .catch((error) => {
            reject(error);
        })
    });
}

export async function getPreApplicationSampleQuestions() {
    return new Promise<any>((resolve, reject) => {
        axios
        .get(apiBaseUrl + "vacancy/preApplicationSampleQuestions")
        .then((response) => {
            resolve(response.data);
        })
        .catch((error) => {
            reject(error);
        })
    });
}

export async function postPreApplicationSampleQuestion(sampleQuestionId: number, recruiterId: number, token: string,jobId?: number) {   
    return new Promise<any>((resolve, reject) => {
        axios 
        .post(apiBaseUrl + "vacancy/preApplicationSampleQuestions", {
            sampleQuestionId,
            jobId
        },
        {
            headers: {
                'Authorization' : `Bearer ${token}`
            },
            params: {
                recruiterId
            }
        })
        .then((response) => { 
            resolve(response.data);
        })
        .catch((error) => {
            reject(error);
        })
    })
}

export async function getSMSService(recruiterId: number, jobId?: number) {   
    return new Promise<any>((resolve, reject) => {
        axios 
        .get(apiBaseUrl + "vacancy/smsService", {
            params: {   
                recruiterId: recruiterId,
                jobId: jobId
            },
            cache: false
        })
        .then((response) => {
            resolve(response.data);
        })
        .catch((error) => {
            reject(error);
        })
    })
}

export async function postSMSMessege(smsSevice: SMSServiceModel, recruiterId: number, token: string,) {
     return new Promise<any>((resolve, reject) => {
        axios 
        .post(apiBaseUrl + "vacancy/smsService", smsSevice, {
            headers: {
                "Content-Type": "application/json",
                'Authorization' : `Bearer ${token}`
            },
            params: {   
                recruiterId: recruiterId
            }
        })
        .then((response) => {
            resolve(response.data);          
        })
        .catch((error) => {
            reject(error);
        })
    })
}

export async function postSMSStatus(status: boolean, jobId?: number) {
    return new Promise<any>((resolve, reject) => {
        axios 
        .put(apiBaseUrl + `vacancy/smsService?status=${status}&jobId=${jobId}`)
        .then((response) => {
            resolve(response.data);          
        })
        .catch((error) => {
            reject(error);
        })
    })
}

export async function getPreApplicationQuestions(recruiterId: number, token: string, jobId?: number) {   
    return new Promise<any>((resolve, reject) => {
        axios 
        .get(apiBaseUrl + "vacancy/preApplicationQuestion", {
            headers: {
                'Authorization' : `Bearer ${token}`
            },
            params: {   
                recruiterId: recruiterId,
                jobId: jobId
            },
            cache: false
        })
        .then((response) => {
            resolve(response.data);
        })
        .catch((error) => {
            reject(error);
        })
    })
}

export async function addQuestiontoJob(newQuestion: JobQuestion, recruiterId: number, token: string) {   
    return new Promise<any>((resolve, reject) => {        
        axios 
        .post(apiBaseUrl + "vacancy/vacancyQuestion", newQuestion, {
            headers: {
                'Authorization' : `Bearer ${token}`
            },
            params: {
                recruiterId
            }
        })
        .then((response) => {
            resolve(response.data);
        })
        .catch((error) => {
            reject(error);
        })
    })
}

export async function updateJobQuestion(jobQuestion: JobQuestion, recruiterId: number, token: string) {
    return new Promise<any>((resolve, reject) => {        
        axios 
        .put(apiBaseUrl + "vacancy/vacancyQuestion", jobQuestion, {
            headers: {
                'Authorization' : `Bearer ${token}`
            },
            params: {
                recruiterId
            }
        })
        .then((response) => {
            resolve(response.data);
        })
        .catch((error) => {
            reject(error);
        })
    })
}

export async function deleteJobQuestion(jobQuestionId: number, recruiterId: number, token: string) {   
    return new Promise<any>((resolve, reject) => {
        axios 
        .delete(apiBaseUrl + `vacancy/vacancyQuestion?jobQuestionId=${jobQuestionId}&recruiterId=${recruiterId}`,{
            headers: {
                'Authorization' : `Bearer ${token}`
            }
        })
        .then((response) => {
            resolve(response.data);
        })
        .catch((error) => {
            reject(error);
        })
    })
}

export async function getVacancyQuestionInitials(recruiterId: number, token: string, jobId?: number) {   
    return new Promise<any>((resolve, reject) => {
        axios 
        .get(apiBaseUrl + "vacancy/vacancyQuestionModel", {
            headers: {
                'Authorization' : `Bearer ${token}`
            },
            params: {   
                recruiterId: recruiterId,
                jobId: jobId
            },
            cache: false
        })
        .then((response) => {
            resolve(response.data);
        })
        .catch((error) => {
            reject(error);
        })
    })
}

export async function updateVacancyQuestionStatus(vacancyQuestionModel: VacancyQuestionModel, recruiterId: number, token: string) {  
    return new Promise<any>((resolve, reject) => {
        axios 
        .post(apiBaseUrl + "vacancy/vacancyQuestionStatus", vacancyQuestionModel, {
            headers: {
                "Content-Type": "application/json",
                'Authorization' : `Bearer ${token}`
            },
            params: {   
                recruiterId: recruiterId
            }
        })
        .then((response) => {
            resolve(response.data);          
        })
        .catch((error) => {
            reject(error);
        })
    })
}

export async function postPreApplicationQuestion(newQuestion: PreApplicationQuestionModel, recruiterId: number, token: string) {   
    return new Promise<any>((resolve, reject) => {
        axios 
        .post(apiBaseUrl + "vacancy/preApplicationQuestion", newQuestion, {
            headers: {
                'Authorization' : `Bearer ${token}`
            },
            params: {
                recruiterId
            }
        })
        .then((response) => {
            resolve(response.data);
        })
        .catch((error) => {
            reject(error);
        })
    });
}

export async function postSampleQuestion(sampleQuestionId: number, recruiterId: number, token: string, jobId?: number) {   
    return new Promise<any>((resolve, reject) => {
        axios 
        .post(apiBaseUrl + "vacancy/sampleVacancyQuestions", {
            sampleQuestionId,
            jobId
        },
        {
            headers: {
                'Authorization' : `Bearer ${token}`
            },
            params: {
                recruiterId
            }
        })
        .then((response) => { 
            resolve(response.data);
        })
        .catch((error) => {
            reject(error);
        })
    })
}

export async function addQuestionToJob(newQuestion: JobQuestion, recruiterId: number, token: string) {   
    return new Promise<any>((resolve, reject) => {        
        axios 
        .post(apiBaseUrl + "vacancy/vacancyQuestion", newQuestion, {
            headers: {
                'Authorization' : `Bearer ${token}`
            },
            params: {
                recruiterId
            }
        })
        .then((response) => {
            resolve(response.data);
        })
        .catch((error) => {
            reject(error);
        })
    })
}

export async function updatePreApplicationQuestion(newQuestion: PreApplicationQuestionModel, recruiterId: number, token: string) {
    return new Promise<any>((resolve, reject) => {
        axios 
        .put(apiBaseUrl + "vacancy/preApplicationQuestion", newQuestion, {
            headers: {
                'Authorization' : `Bearer ${token}`
            },
            params: {
                recruiterId
            }
        })
        .then((response) => {
            resolve(response.data);
        })
        .catch((error) => {
            reject(error);
        })
    })
}

export async function deletePreApplicationQuestion(jobQuestionId: number, recruiterId: number, token: string) {   
    return new Promise<any>((resolve, reject) => {
        axios 
        .delete(apiBaseUrl + `vacancy/preApplicationJobQuestion?jobQuestionId=${jobQuestionId}&recruiterId=${recruiterId}`, {
            headers: {
                'Authorization' : `Bearer ${token}`
            }
        })
        .then((response) => {
            resolve(response.data);
        })
        .catch((error) => {
            reject(error);
        })
    })
}

export async function getStageEmailInitials(jobId?: number) {   
    return new Promise<any>((resolve, reject) => {
        axios 
        .get(apiBaseUrl + "vacancy/stageEmailModel",{
            params: {   
                jobId: jobId
            },
            cache: { ttl: 0 } 
        })
        .then((response) => {
            resolve(response.data);
        })
        .catch((error) => {
            reject(error);
        })
    })
}

export async function postStageEmailTemplate(emailModel: JobApplicationStageEmail, recruiterId: number, token: string) {
    return new Promise<any>((resolve, reject) => {
        axios 
        .post(apiBaseUrl + "vacancy/stageEmailTemplate", emailModel, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization' : `Bearer ${token}`
            },
            params: {   
                recruiterId: recruiterId
            }
        })
        .then((response) => {
            resolve(response.data);          
        })
        .catch((error) => {
            reject(error);
        })
    })
}

export async function updateStageEmailTemplate(emailModel: JobApplicationStageEmail, recruiterId: number, token: string) {
    return new Promise<any>((resolve, reject) => {
        axios 
        .put(apiBaseUrl + "vacancy/stageEmailTemplate", emailModel, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization' : `Bearer ${token}`
            },
            params: {   
                recruiterId: recruiterId
            }
        })
        .then((response) => {
            resolve(response.data);          
        })
        .catch((error) => {
            reject(error);
        })
    })
}

export async function deleteStageEmailTemplate(stageEmailId: number, recruiterId: number, token: string) {
    return new Promise<any>((resolve, reject) => {
        axios 
        .delete(apiBaseUrl + `vacancy/stageEmailTemplate`, {
            headers: {
                'Authorization' : `Bearer ${token}`
            },
            params: {  
                stageEmailId: stageEmailId,
                recruiterId: recruiterId
            }
        })
        .then((response) => {
            resolve(response.data);
        })
        .catch((error) => {
            reject(error);
        })
    })
}

export async function submitVacancy(recruiterId: number, token: string, jobId?: number) {   
    return new Promise<any>((resolve, reject) => {
        axios 
        .post(apiBaseUrl + "vacancy/submitVacancy", null , {
            headers: {
                'Authorization' : `Bearer ${token}`
            },
            params: {
                recruiterId: recruiterId,
                jobId: jobId
            }
        })
        .then((response) => { 
            resolve(response.data);
        })
        .catch((error) => {
            reject(error);
        })
    })
}

export async function getVacancyDetails(recruiterId: number, token: string, jobId?: number) {   
    return new Promise<any>((resolve, reject) => {
        axios 
        .get(apiBaseUrl + "vacancy/vacancyDetails", {
            params: {   
                recruiterId: recruiterId,
                jobId: jobId
            },
            headers: {
                'Authorization' : `Bearer ${token}`
            },
            cache: false
        })
        .then((response) => {
            resolve(response.data);
        })
        .catch((error) => {
            reject(error);
        })
    })
}

export async function editVacancyQuestions(details: VacancyEditResponse, token: string) {
    return new Promise<any>((resolve, reject) => {
        axios 
        .post(apiBaseUrl + "vacancy/editVacancyQuestions", details, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization' : `Bearer ${token}`
            },
        })
        .then((response) => {
            resolve(response.data);          
        })
        .catch((error) => {
            reject(error);
        })
    })
}

export async function editCVLessQuestions(details: VacancyEditResponse, token: string ) {
    return new Promise<any>((resolve, reject) => {
        axios 
        .post(apiBaseUrl + "vacancy/editCVLessQuestions", details, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization' : `Bearer ${token}`
            }
        })
        .then((response) => {
            resolve(response.data);          
        })
        .catch((error) => {
            reject(error);
        })
    })
}

export async function editReplyMails(details: VacancyEditResponse, token: string) {
    return new Promise<any>((resolve, reject) => {
        axios 
        .post(apiBaseUrl + "vacancy/editReplyMails", details, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization' : `Bearer ${token}`
            }
        })
        .then((response) => {
            resolve(response.data);
        })
        .catch((error) => {
            reject(error);
        })
    })
}